import React from 'react';
import { connect } from 'react-redux';
import { cloneDeep } from '../../../../../utils/lodash';

import { TableRow, ButtonBase, TableCell, TextField } from '@mui/material';

import { Popover } from '@mui/material';
import TrplSelect from '../../../../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../../../../common/TrplControls/TrplCheckbox';
import Filters from '../../../../../common/Filters';
import Sorters from '../../../../../common/Sorters';
import Node from '../../../../../common/Node';
import ArrowTooltipCss from '../../../../../common/ArrowTooltipCss';

import { SortableElement, sortableHandle } from 'react-sortable-hoc';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import FilterIcon from '@mui/icons-material/FilterList';
import DragIcon from '@mui/icons-material/DragIndicator';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import {
  getRstDataMap,
  getAllFormConcepts,
  getLinksSelectValues,
  isNotPlaceholderFilter,
} from '../../../../../utils';
import { SortByAlphaRounded } from '@mui/icons-material';

const DragHandle = sortableHandle(({ classes }) => (
  <div style={{}} className={classes.rowDragHandle}>
    <DragIcon className={`drag-handle-icon ${classes.boundValueDragIcon}`} />
  </div>
));

export default connect((state) => ({ jels: state.jels }))(
  SortableElement(
    ({
      link,
      jels,
      classes,
      rowIndex,
      setupRbox,
      linkIndex,
      groupIndex,
      removeGroupLink,
      openTblEditModal,
      openFrmEditModal,
      onGroupLinkChange,
    }) => {
      const [anchorElFiter, setAnchorElFilter] = React.useState(null);
      const [anchorElSorter, setAnchorElSorter] = React.useState(null);
      const [filterAncestor, setFilterAncestor] = React.useState(0);
      const [filterConceptKey, setFilterConceptKey] = React.useState('');

      const isLinkUrlDisabled = !!(link.jel && link.jel !== 'none');
      const isLinkJelDisabled = !!(link && link.url && !!link.url.length);

      const jelSelectValue = link.jel && jels.jelData[link.jel] ? link.jel : 'none';
      const jelSelectDisabled = jelSelectValue === 'none';
      const linksSelectValues = getLinksSelectValues(jels);

      const linkSelectedViewJel = link.jel && jels.jelData[link.jel];

      const openFilters = Boolean(anchorElFiter);
      const openSorter = Boolean(anchorElSorter);

      const getFilterKey = (conceptKey) => {
        const filterKey = conceptKey ? 'view_filters_' + conceptKey : 'view_filters';

        return filterKey;
      }

      const setFiltersToState = (filters) => {
        const cleanedFilters = cloneDeep(filters.filter(isNotPlaceholderFilter));
        const filterKey = getFilterKey(filterConceptKey);

        onGroupLinkChange(rowIndex, groupIndex, linkIndex, filterKey, cleanedFilters);
      };

      const jelConcepts = getAllFormConcepts(linkSelectedViewJel);
      
      const initialSorter = link.view_sorter;
      const setSorterToState = (sorter) => {
        return onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'view_sorter', sorter);
      };

      let rstDataMap;
      if (filterAncestor) rstDataMap = getRstDataMap(null, filterAncestor, setupRbox);
      else if (linkSelectedViewJel && linkSelectedViewJel.concept) rstDataMap = getRstDataMap(null, linkSelectedViewJel.concept, setupRbox);

      return (
        <TableRow className={`trpl-edit-rst-row`} style={{ opacity: link.hidden ? '0.5' : 1}}>
          <Popover
            id={`filters-popover-${linkIndex}`}
            anchorEl={anchorElFiter}
            open={openFilters}
            onClose={() => setAnchorElFilter(null)}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Filters
              nodes={setupRbox}
              defaultBg={true}
              ancestor={filterAncestor}
              filterByNodeTitle={true}
              callbacks={{
                setFiltersToParentState: setFiltersToState,
              }}
              loaded={true}
              rstDataMap={rstDataMap}
              initialFilters={link[getFilterKey(filterConceptKey)]}
            />
          </Popover>
          <Popover
            id={`sorters-popover-${linkIndex}`}
            PaperProps={{
              style: {
                marginTop: '10px',
                overflow: 'visible',
                boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
              },
            }}
            anchorEl={anchorElSorter}
            open={openSorter}
            onClose={() => setAnchorElSorter(null)}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Sorters
              callbacks={{
                setSorters: setSorterToState,
              }}
              initialSorters={initialSorter}
              rstDataMap={rstDataMap}
            />
          </Popover>
          <TableCell className={classes.tCell}>
            <div className={classes.alignCenter}>
              <ClearIcon
                color="secondary"
                className={`${classes.mr5} ${classes.pointer}`}
                style={{ fontSize: '14px' }}
                onClick={() => removeGroupLink(rowIndex, groupIndex, linkIndex)}
              />

              <div>
                <DragHandle classes={classes} />
              </div>
            </div>
          </TableCell>

          <TableCell className={classes.tCell}>
            <TextField
              value={link.title || ''}
              className={`${classes.fw} ${classes.mr10}`}
              onChange={(e) => onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'title', e.target.value)}
            />
          </TableCell>

          <TableCell className={classes.tCell}>
            <TextField
              value={link.url || ''}
              disabled={isLinkUrlDisabled}
              className={`${classes.fw} ${classes.mr10}`}
              onChange={(e) => onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'url', e.target.value)}
            />
          </TableCell>

          <TableCell className={classes.tCell} style={{ width: '112px' }}>
            <TrplCheckbox
              value={link.target}
              checked={link.target}
              style={{ flexShrink: 0 }}
              onChange={(e) => onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'target', e.target.checked)}
            />
          </TableCell>

          <TableCell className={classes.tCell} style={{ width: 'fit-content' }}>
            <div className={classes.alignCenter}>
              {jelConcepts ? Object.keys(jelConcepts).map(conceptKey => {
                let conceptKeyNumber = '';
                if (conceptKey.startsWith('concept_')) conceptKeyNumber = conceptKey.split('_')[1];

                const filterKey = getFilterKey(conceptKeyNumber);

                return (
                  <div key={conceptKey} className={`${classes.alignCenter} ${classes.mr10}`}>
                    <div className={classes.mr5}>
                      <Node
                        isLink
                        size="xs"
                        nodes={setupRbox}
                        nodeId={jelConcepts[conceptKey]}
                        node={jelConcepts[conceptKey] ? setupRbox[jelConcepts[conceptKey]] : null}
                      />
                    </div>
                    <ArrowTooltipCss text={'Filters'}>
                      <FilterIcon
                        style={link[filterKey] && link[filterKey].length
                          ? { background: '#D6E5FF', borderRadius: '3px', color: '#4c4c4c', cursor: 'pointer' }
                          : { background: '#EEECF8', color: '#878787', cursor: 'pointer' }
                        }
                        onClick={(e) => {
                          setFilterAncestor(jelConcepts[conceptKey]);
                          setFilterConceptKey(conceptKeyNumber);
                          setAnchorElFilter(e.currentTarget);
                        }}
                      />
                    </ArrowTooltipCss>
                  </div>
                )
              }) : null}

              {linkSelectedViewJel && linkSelectedViewJel.type === 'table' ?
                <div className={classes.mr10}>
                  <ArrowTooltipCss text={'Sorter'}>
                    <SortByAlphaRounded
                      style={initialSorter && Object.values(initialSorter).length
                        ? { background: '#D6E5FF', borderRadius: '3px', color: '#4c4c4c', cursor: 'pointer' }
                        : { background: '#EEECF8', color: '#878787', cursor: 'pointer' }
                      }
                      onClick={(e) => setAnchorElSorter(e.currentTarget)}
                    />
                  </ArrowTooltipCss>
              </div> : null}
            </div>
          </TableCell>

          <TableCell className={classes.tCell} style={{ width: '200px' }}>
            <TrplSelect
              margin="none"
              complicatedValues
              values={linksSelectValues}
              placeholder='Select view'
              firstChilds={
                <React.Fragment>
                  <ButtonBase
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      openFrmEditModal(rowIndex, groupIndex, linkIndex);
                    }}
                    className={`${classes.btnGray} ${classes.mb5}`}
                  >
                    Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                  </ButtonBase>

                  <ButtonBase
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      openTblEditModal(rowIndex, groupIndex, linkIndex);
                    }}
                    className={`${classes.btnGray} ${classes.mb5}`}
                  >
                    Create table <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                  </ButtonBase>
                </React.Fragment>
              }
              disabled={isLinkJelDisabled}
              onChange={(e) => {
                onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'jel', e.target.value);
              }}
              value={jelSelectValue}
            />
          </TableCell>

          <TableCell className={classes.tCell} style={{ width: '50px' }}>
            <ButtonBase
              disabled={jelSelectDisabled}
              style={{
                opacity: `${jelSelectDisabled ? '0.5' : ''}`,
              }}
            >
              <EditIcon
                style={{ display: 'flex', opacity: `${!link.jel || (link.jel && link.jel === 'none') ? '0.5' : '1'}` }}
                className={classes.editFrmIcon}
                onClick={() => {
                  if (jels.jelData[link.jel] && jels.jelData[link.jel].type === 'table') {
                    openTblEditModal(rowIndex, groupIndex, linkIndex, jels.jelData[link.jel]);
                  } else {
                    openFrmEditModal(rowIndex, groupIndex, linkIndex, jels.jelData[link.jel]);
                  }
                }}
              />
            </ButtonBase>
          </TableCell>

          <TableCell className={classes.tCell} style={{ width: '50px', paddingTop: '5px' }}>
            {link.hidden ?
              <ArrowTooltipCss text={'Show link row'}>
                <VisibilityOffOutlinedIcon onClick={() => onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'hidden', false)}/>
              </ArrowTooltipCss>
              :
              <ArrowTooltipCss text={'Hide link row'}>
                <VisibilityOutlinedIcon onClick={() => onGroupLinkChange(rowIndex, groupIndex, linkIndex, 'hidden', true)}/>
              </ArrowTooltipCss>
            }
          </TableCell>
        </TableRow>
      );
    }
  )
);
